(ns app.front.view.committees.appeals
  (:require [app.domain.appeals.model :as appeals-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.util :as futil]
            [app.front.view.committees.common :as committee-common]
            [app.front.view.committees.subs :as committee-subs]
            [app.front.view.group.admin.subs :as gas]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))


(rf/reg-sub ::all-tribunals
  :<- [::entities/entities {:entity/type :entity.type/appeals-tribunal}]
  (fn [tribunals _] tribunals))

(rf/reg-event-db ::set-show-inactive-tribunals?
  (fn [db [_ value]]
    (assoc db ::show-inactive-tribunals? value)))

(rf/reg-sub ::show-inactive-tribunals?
  :-> ::show-inactive-tribunals?)

(rf/reg-sub ::tribunals
  :<- [::all-tribunals]
  :<- [::gas/group-id]
  :<- [::show-inactive-tribunals?]
  :<- [:language]
  (fn [[tribunals group-id show-inactive? lang] _]
    (->> tribunals
         (filter #(-> % :entity/parent :db/id (= group-id)))
         (filter #(or show-inactive?
                      (du/in-state? :appeals-tribunal.state/active %)))
         (sort-by #(-> %
                       (appeals-model/appeals-tribunal-name lang)
                       str/lower-case)))))

(rf/reg-event-db ::show-add-tribunal
  (committee-subs/show-add-handler :add-tribunal))


(rf/reg-sub ::add-tribunal-status
  :<- [::committee-subs/statuses]
  (fn [status _]
    (-> status :add-tribunal (get nil))))


(rf/reg-event-db ::hide-add-tribunal
  (committee-subs/hide-add-handler :add-tribunal))


(rf/reg-event-fx ::create-tribunal
  (fn [{:keys [db]} [_ authority-group-id params]]
    {:db           (-> db
                       (update ::committee-subs/status assoc-in [:add-tribunal nil] :in-progress))
     :comm/command {:command    :appeals-tribunal/create
                    :data       (-> params
                                    (assoc :authority-group-id authority-group-id))
                    :on-success [::create-tribunal.success nil]
                    :notify     {:success :appeals/tribunal-created}}}))

(rf/reg-event-fx ::create-tribunal.success
  (fn [{:keys [db]} [_ id status resp]]
    {:db       (-> db
                   (update ::committee-subs/status assoc-in [:add-tribunal id] :done))
     :dispatch [::entities/apply-changes status resp]}))

(rf/reg-event-fx ::delete-tribunal
  (fn [_ [_ tribunal-id]]
    {:comm/command {:command    :appeals-tribunal/delete
                    :data       (util/mmap tribunal-id)
                    :notify     {:success :appeals/tribunal-deleted}
                    :on-success [::committee-subs/delete.success]}}))

(rf/reg-event-fx ::retract-tribunal
  (fn [_ [_ tribunal-id]]
    {:comm/command {:command    :appeals-tribunal/retract
                    :data       (util/mmap tribunal-id)
                    :notify     {:success :appeals/tribunal-retracted}
                    :on-success [::entities/apply-changes]}}))

(rf/reg-event-fx ::edit-tribunal
  (fn [{:keys [db]} [_ tribunal]]
    {:db           (-> db
                       (committee-subs/set-edit-status (:db/id tribunal) :in-progress))
     :comm/command {:command    :appeals-tribunal/edit
                    :data       tribunal
                    :notify     {:success :appeals/tribunal-updated}
                    :on-success [::edit-tribunal.success (:db/id tribunal)]}}))

(rf/reg-event-fx ::edit-tribunal.success
  (fn [{:keys [db]} [_ tribunal-id status resp]]
    {:db       (-> db
                   (committee-subs/set-edit-status tribunal-id :done))
     :dispatch [::entities/apply-changes status resp]}))

(def tribunal-attrs
  {:name-attr :appeals-tribunal/names
   :desc-attr :appeals-tribunal/descriptions
   :name-fn   appeals-model/appeals-tribunal-name
   :desc-fn   appeals-model/appeals-tribunal-description})

(defn tribunal-item [{id :db/id :as tribunal}]
  (let [status (<sub [::committee-subs/edit-item-status id])
        tr     (<sub [:tr])]
    [committee-common/list-item
     (merge tribunal-attrs
            {:item                     tribunal
             :on-save                  #(>evt [::edit-tribunal %])
             :on-cancel                #(>evt [::committee-subs/set-edit-item-status id nil])
             :on-edit                  #(>evt [::committee-subs/set-edit-item-status id :editing])
             :on-delete                #(>evt [::delete-tribunal id])
             :active?                  (du/in-state? :appeals-tribunal.state/active tribunal)
             :delete-title             (tr [:appeals/delete-tribunal-confirm-title])
             :delete-confirm-content   (tr [:appeals/delete-tribunal-confirm-content])
             :status                   status
             :on-retract               #(>evt [::retract-tribunal id])
             :retractable?             (<sub [::committee-subs/retractable? id])
             :retract-title            (tr [:appeals/retract-tribunal-confirm-title])
             :retract-confirm-content  (tr [:appeals/retract-tribunal-confirm-content])
             :retract-not-allowed-info (tr [:appeals/retract-tribunal-not-allowed-info])})]))

(defn show-inactive-toggle []
  (let [tr             (<sub [:tr])
        show-inactive? (<sub [::show-inactive-tribunals?])]
    [:div.mb-6
     (cc/toggle {:id         "show-inactive-tribunals"
                 :label-text (tr [:appeals/show-inactive-tribunals])
                 :labelA     (tr [:no])
                 :labelB     (tr [:yes])
                 :on-toggle  #(>evt [::set-show-inactive-tribunals? %])
                 :toggled    (boolean show-inactive?)})]))

(defn tribunals-list []
  (let [tr        (<sub [:tr])
        tribunals (<sub [::tribunals])]
    (if (seq tribunals)
      [:ul
       (futil/for-frag [tribunal tribunals]
         [tribunal-item tribunal])]
      [committee-common/empty-text
       (tr [(if (<sub [::show-inactive-tribunals?])
              :appeals/no-tribunals
              :appeals/no-active-tribunals)])])))


(defn add-tribunal []
  (let [authority-group-id (<sub [::gas/group-id])
        tr                 (<sub [:tr])]
    [committee-common/add-widget
     {:state        (<sub [::add-tribunal-status])
      :on-start-add #(>evt [::show-add-tribunal])}
     [committee-common/add-entity-widget
      (merge tribunal-attrs
             {:title     (tr [:appeals/add-tribunal])
              :on-create #(>evt [::create-tribunal authority-group-id %])
              :on-cancel #(>evt [::hide-add-tribunal])})]]))
